<div class="modal-header pb-0 border-0 d-flex align-items-center" style="color: #000;">
    <div class="d-flex align-items-center gap-2">
        <div class="header-icon-container">
            <iconify-icon
                icon="material-symbols:lock"
                class="header-icon">
            </iconify-icon>
        </div>
        <div class="ml-2">
            <h1 class="modal-title font-weight-bold mb-0 modal-heading" style="color: #000;">
                Change Password
            </h1>
        </div>
    </div>
    <button type="button" class="close mb-0" style="color: #000;" (click)="modalRef.hide()">
        <span>&times;</span>
    </button>
</div>

<hr class="mt-2 mb-0 opacity-100" style="background-color: #CCCCCC; border: solid 2px #CCCCCC;">

<div class="modal-body">

    <!-- Current Password -->
    <div class="form-group">
        <label class="form-control-label">
            Current Password
            <app-tooltip text="Current password is required." position="top">
                <i class="fas fa-info-circle ml-1" style="font-size: 0.85rem; color: #595959;"></i>
            </app-tooltip>
        </label>
        <div class="input-group input-group-alternative" [class.error-border]="currentPasswordError">
            <input
            class="form-control"
            placeholder="Enter current password"
            [type]="showCurrentPassword ? 'text' : 'password'"
            [(ngModel)]="currentPassword"
            (blur)="onCurrentPasswordBlur()"
            (ngModelChange)="onAnyChange()"
            name="currentPassword"
            />
            <div class="input-group-append">
                <span 
                    class="input-group-text" 
                    style="cursor:pointer;" 
                    (click)="toggleCurrentPasswordVisibility()"
                >
                    <iconify-icon *ngIf="showCurrentPassword"
                        icon="mdi:eye"
                        style="color: #595959;"
                        width="20" height="20">
                    </iconify-icon>
                    <iconify-icon *ngIf="!showCurrentPassword"
                        icon="famicons:eye-off-sharp"
                        style="color: #E5E5E5;"
                        width="20" height="20">
                    </iconify-icon>
                </span>
            </div>
        </div>
        <small class="text-danger error-line" *ngIf="currentPasswordError">{{ currentPasswordError }}</small>
    </div>

    <!-- New Password -->
    <div class="form-group">
        <label class="form-control-label">
            New Password
            <app-tooltip text="Must be at least 8 characters, with uppercase, lowercase, and a number." position="top">
                <i class="fas fa-info-circle ml-1" style="font-size: 0.85rem; color: #595959;"></i>
            </app-tooltip>
        </label>
        <div class="input-group input-group-alternative" [class.error-border]="newPasswordError">
            <input
                class="form-control"
                placeholder="Enter new password"
                [type]="showNewPassword ? 'text' : 'password'"
                [(ngModel)]="newPassword"
                (blur)="onNewPasswordBlur()"
                (ngModelChange)="onAnyChange()"
                name="newPassword"
            />
            <div class="input-group-append">
                <span 
                    class="input-group-text" 
                    style="cursor:pointer;" 
                    (click)="toggleNewPasswordVisibility()"
                >
                    <iconify-icon *ngIf="showNewPassword"
                        icon="mdi:eye"
                        style="color: #595959;"
                        width="20" height="20">
                    </iconify-icon>
                    <iconify-icon *ngIf="!showNewPassword"
                        icon="famicons:eye-off-sharp"
                        style="color: #E5E5E5;"
                        width="20" height="20">
                    </iconify-icon>
                </span>
            </div>
        </div>
        <small class="text-danger error-line" *ngIf="newPasswordError">{{ newPasswordError }}</small>
    </div>

    <!-- Confirm Password -->
    <div class="form-group mb-0">
        <label class="form-control-label">
            Confirm Password
            <app-tooltip text="Re-enter your new password to confirm." position="top">
                <i class="fas fa-info-circle ml-1" style="font-size: 0.85rem; color: #595959;"></i>
            </app-tooltip>
        </label>
        <div class="input-group input-group-alternative" [class.error-border]="newPasswordConfirmError">
            <input
                class="form-control"
                placeholder="Enter new password"
                [type]="showNewPasswordConfirm ? 'text' : 'password'"
                [(ngModel)]="newPasswordConfirm"
                (blur)="onNewPasswordConfirmBlur()"
                (ngModelChange)="onAnyChange()"
                name="newPasswordConfirm"
            />
            <div class="input-group-append">
                <span 
                    class="input-group-text" 
                    style="cursor:pointer;" 
                    (click)="toggleNewPasswordConfirmVisibility()"
                >
                    <iconify-icon *ngIf="showNewPasswordConfirm"
                        icon="mdi:eye"
                        style="color: #595959;"
                        width="20" height="20">
                    </iconify-icon>
                    <iconify-icon *ngIf="!showNewPasswordConfirm"
                        icon="famicons:eye-off-sharp"
                        style="color: #E5E5E5;"
                        width="20" height="20">
                    </iconify-icon>
                </span>
            </div>
        </div>
        <small class="text-danger error-line" *ngIf="newPasswordConfirmError">{{ newPasswordConfirmError }}</small>
    </div>

</div>

<div class="modal-footer" style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);">
    <div class="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-sm-end w-100 gap-2">
        <div class="d-flex flex-row justify-content-center justify-content-sm-end" style="gap: 8px; flex-shrink: 0;">
            <button type="button" class="btn btn-md grant-btn px-4"
                [disabled]="isSubmitting"
                (click)="changePassword()">
                <i class="fas fa-check mr-1"></i> Change Password
            </button>
            <button type="button" class="btn btn-md cancel-btn px-4"
                (click)="modalRef.hide()">
                Cancel
            </button>
        </div>
    </div>
</div>